import { History } from "history";

export type NavigateToSchoolWorkspaceOptions = {
  path: string;
  schoolId?: string | null;
  state?: Record<string, unknown>;
  search?: string;
};

export const navigateToSchoolWorkspace = (
  history: History,
  setActiveSchoolId: (schoolId?: string | number | null) => void,
  { path, schoolId, state, search }: NavigateToSchoolWorkspaceOptions,
) => {
  if (schoolId) {
    setActiveSchoolId(schoolId);
  }

  history.push({
    pathname: path,
    search: search || undefined,
    state,
  });
};
